export const Line = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="117"
      height="2"
      viewBox="0 0 117 2"
      fill="none"
    >
      <path
        d="M117 1C117 0.447715 116.552 0 116 0H1C0.447716 0 0 0.447715 0 1C0 1.55228 0.447716 2 1 2H116C116.552 2 117 1.55228 117 1Z"
        fill="#8A8A9B"
      />
    </svg>
  );
};

